import * as form from '../form';

export const financialCivilJudgement = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        AmountOfJudgement: form.number(xitem.AmountOfJudgement),
        AmountOfJudgementEstimated: form.checkbox(xitem.AmountOfJudgementEstimated),
        Why: form.textarea(xitem.Why),
        When: form.datecontrol(xitem.When),
        HasBeenPaid: form.branch(xitem.HasBeenPaid),
        WhenPaid: form.datecontrol(xitem.WhenPaid),
        ActionsTaken: form.textarea(xitem.ActionsTaken),
        ActionsTakenNone: form.notapplicable(xitem.ActionsTakenNone),
        ActionsTakenReason: form.textarea(xitem.ActionsTakenReason),
        CourtName: form.text(xitem.CourtName),
        CourtLocation: form.location(xitem.CourtLocation),
        OrderNum: form.text(xitem.OrderNum),
        OrderNumIdk: form.notapplicable(xitem.OrderNumIdk),
        OtherParties: form.textarea(xitem.OtherParties),
      },
    };
  });
  return {
    HasCivilJudgement: form.branch(data.HasCivilJudgement),
    List: form.collection(items, (data.List || {}).branch),
  };
};
